import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useSelector } from 'react-redux';

const ContributorsHeader = (props) => {
    const { editContributorClicked, contributors, isOwner } = props;
    const [contributorsHeaderOpen, setContributorsHeaderOpen] = useState(false);
    const isAdmin = useSelector((state) => state.user.admin);

    return (
        <>
            <div className='info-header'>
                <div className='info-header__title' id='info-header-title' onClick={() => setContributorsHeaderOpen(!contributorsHeaderOpen)}>
                    <div className='info-header__title-text-container'>
                        <div className='info-header__title-text'>Contributors</div>
                        {contributorsHeaderOpen ? (
                            <KeyboardArrowDownIcon className='info-header__title-icon' />
                        ) : (
                            <KeyboardArrowRightIcon className='info-header__title-icon' />
                        )}
                    </div>
                </div>
                {contributorsHeaderOpen && contributors.length === 0 && <div className='info-header__grid'>No contributors have been added</div>}
                {contributorsHeaderOpen &&
                    contributors.length > 0 &&
                    contributors.map((contributor, index) => {
                        return (
                            <Grid container key={index} className='info-header__grid'>
                                <Grid className='info-header__grid-title'>
                                    <Typography className='info-header__item-title'>{`${contributor.firstName} ${contributor.lastName}`}</Typography>
                                </Grid>
                                <Grid className='info-header__grid-body'>
                                    <Typography className='info-header__item-body-row'>
                                        <Typography>{contributor.email}</Typography>
                                        {(isAdmin || isOwner) && (
                                            <EditIcon onClick={() => editContributorClicked(contributor)} fontSize='small' className='info-header__edit-icon' />
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        );
                    })}
            </div>
            {contributorsHeaderOpen && <div className='info-header__divider' />}
        </>
    );
};

export default ContributorsHeader;
